import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useCallback, useContext } from 'react';
import { useRoutes } from '../../hooks/useRoutes';
import { withScrollThreshold } from '../../shared-components/elementis/hoc/withScrollThreshold';
import IdentityContext from '../../contexts/IdentityContext';
import ApplicationLevelLayout from '../../layout/ApplicationLevelLayout';
import Role from '../../core/security/role';
import useGroupInviteToasts from '../my-teachers/hooks/useGroupInviteToasts';

import Page from '@pelckmans/elementis/components/page';
import Tabs from '@pelckmans/elementis/components/tabs';
import useStudioGroup from '../../hooks/useStudioGroup';

export const TABS = {
  DASHBOARD: 'DASHBOARD',
  CATALOGUE: 'CATALOGUE',
};

function MyMethods() {
  const {
    identity: { highestRole },
  } = useContext(IdentityContext);
  const studioGroup = useStudioGroup();
  const isCodeBasedStudent = (studioGroup === 'VO' || studioGroup === 'BAO') && highestRole === Role.STUDENT;
  const location = useLocation();
  const { getRoute } = useRoutes();
  const navigate = useNavigate();

  const selectedTab = location.pathname.includes(getRoute('MY_METHODS.DASHBOARD')) ? TABS.DASHBOARD : TABS.CATALOGUE;

  useGroupInviteToasts();

  const onTabChange = useCallback(
    (tab: string) => {
      if (tab === selectedTab) return;

      const route = tab === TABS.DASHBOARD ? getRoute('MY_METHODS.DASHBOARD') : getRoute('MY_METHODS.CATALOGUE');

      navigate(route);
    },
    [getRoute, navigate, selectedTab],
  );

  return (
    <ApplicationLevelLayout>
      <Page>
        {isCodeBasedStudent ? (
          <Outlet />
        ) : (
          <Tabs selectedTab={selectedTab} onTabChange={onTabChange}>
            <Outlet />
          </Tabs>
        )}
      </Page>
    </ApplicationLevelLayout>
  );
}

export default withScrollThreshold(MyMethods);
